import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LanguageService {
    #currentLang: BehaviorSubject<string> = new BehaviorSubject<string>('es');
    #translate: TranslateService = inject(TranslateService);

    constructor() {
        this.#translate.use(this.getBrowserLanguage());
        this.#translate.onLangChange.subscribe((event) => {
            this.#currentLang.next(event.lang);
        });
    }

    get currentLang(): Observable<string> {
        return this.#currentLang.asObservable();
    }

    getBrowserLanguage(): string {
        const userLang = this.#translate.getBrowserLang();

        if (userLang.indexOf('en') >= 0) {
            return 'en';
        } else if (userLang.indexOf('es') >= 0) {
            return 'es';
        } else if (userLang.indexOf('fr') >= 0) {
            return 'fr';
        } else if (userLang.indexOf('pt') >= 0) {
            return 'pt';
        } else if (userLang.indexOf('eu') >= 0) {
            return 'eu';
        } else {
            // Default language
            return 'es';
        }
    }
}
